module.exports = __webpack_public_path__ + "static/media/web-icon.ec8e49a9.svg";